import {
  Alert,
  Checkbox,
  CheckboxProps,
  ShorthandValue,
  Text,
  TextProps,
} from "@fluentui/react-northstar";
import { FieldDescriptor } from "@shopify/react-form-state";
import React from "react";

import { FieldLabel, FieldLabelProps } from ".";

type Props = {
  label?: ShorthandValue<TextProps>;
  labelProps?: Partial<FieldLabelProps>;
  field: FieldDescriptor<boolean>;
  style?: React.CSSProperties;
  tooltip?: React.ReactNode;
  trueLabel?: ShorthandValue<TextProps>;
  falseLabel?: ShorthandValue<TextProps>;
  className?: string;
  note?: string;
} & CheckboxProps;

export const CheckboxField: React.FC<Props> = ({
  field,
  label,
  labelProps,
  style,
  className,
  tooltip,
  trueLabel,
  falseLabel,
  note,
  ...inputProps
}) => {
  return (
    <div style={style} className={className}>
      {label && (
        <FieldLabel
          label={label}
          tooltip={tooltip}
          size="medium"
          disabled={inputProps.disabled}
          {...labelProps}
        />
      )}
      <Checkbox
        onChange={(_e, d) => field.onChange(d ? d.checked === true : false)}
        styles={{ marginTop: ".25rem" }}
        id={field.name}
        checked={field.value}
        label={field.value ? trueLabel : falseLabel}
        {...inputProps}
      />
      {note && <Text as="div" content={note} weight="light" size="smaller" />}
      {field.error && <Alert content={field.error} danger attached="bottom" />}
    </div>
  );
};
